import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LoaderService } from './common/templates/loader/templates/loader/loader.service';
import { LoaderConstants } from './common/templates/loader/modules/loader.constants';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter, map } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false,
    styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
    title = 'mc-ob-test-app-merchant';
    buttonLoader = LoaderConstants.buttonLoader;

    constructor(
        public readonly loaderService: LoaderService,
        private readonly cdr: ChangeDetectorRef,
        private readonly updates: SwUpdate
    ) {}

	ngOnInit() {
        // Subscribe to the isLoading$ observable and manually trigger change detection
        // when the value changes
        this.loaderService.isLoading$.subscribe(() => {
            this.cdr.detectChanges();
        });

		this.checkForUpdates().then(() => console.log('Update check completed'));
    }

	async checkForUpdates() {
		const updatesAvailable = this.updates.versionUpdates.pipe(
            filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
            map((evt) => ({
                type: 'UPDATE_AVAILABLE',
                current: evt.currentVersion,
                available: evt.latestVersion,
            }))
        );
        updatesAvailable.subscribe({
            next: (evt) => {
                if (evt.type === 'UPDATE_AVAILABLE') {
                    window.location.reload();
                }
            },
        });
        if (this.updates.isEnabled) {
            // This promise will return when the update check is completed,
            // and if an update is available, it will also wait for the update
            // to be downloaded (at which point it calls our callback above and
            // we just need to reload the page to apply it).
            await this.updates.checkForUpdate();
        }
	}
}
